// given a mm/dd/yyyy date string, return a string date with format of
// Day, Month DD, YYYY | 18:00 PM <timezone>
// e.g. Friday, December 25, 2020 | 18:00 PM UTC
export function formatDate(date: Date) {
  const dayOfWeek = date.toLocaleString('default', { weekday: 'long' });
  const month = date.toLocaleString('default', { month: 'long' });
  const day = date.getDate();
  const year = date.getFullYear();

  return `${dayOfWeek}, ${month} ${day}, ${year}`;
}

export function formatTime(date: Date) {
  const time = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  const timezone = date.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ')[2];

  return `${time} ${timezone}`;
}

export function formatDateString(dateString: string) {
  const date = new Date(dateString);

  if (!date) {
    return '';
  }
  return formatDate(date);
}

export function formatTimeString(dateString: string) {
  const date = new Date(dateString);

  if (!date) {
    return '';
  }
  return formatTime(date);
}
export function getTimeDifference(current: Date, previous: Date) {
  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;

  const elapsed = current.getTime() - previous.getTime();

  if (elapsed < msPerMinute) {
    return `${Math.round(elapsed / 1000)} seconds ago`;
  }

  if (elapsed < msPerHour) {
    return `${Math.round(elapsed / msPerMinute)} minutes ago`;
  }

  if (elapsed < msPerDay) {
    return `${Math.round(elapsed / msPerHour)} hours ago`;
  }

  if (elapsed < msPerMonth) {
    return `${Math.round(elapsed / msPerDay)} days ago`;
  }

  if (elapsed < msPerYear) {
    return `${Math.round(elapsed / msPerMonth)} months ago`;
  }

  return `${Math.round(elapsed / msPerYear)} years ago`;
}
